import React from 'react';

const Pay = () => {
    return (
        <div style={{ textAlign: 'center' }}>
            <h3>Developer is sleeping</h3>
        </div>
    );
};

export default Pay;